import React from 'react';
import { loginWithGoogle } from '../../firebase/authService';
import { School, ArrowRight, ShieldCheck } from 'lucide-react';

const Login = () => {
    const handleLogin = async () => {
        try {
            await loginWithGoogle();
        } catch (error) {
            alert(error.message || "Error al iniciar sesión");
        }
    };

    return (
        <div className="min-h-screen w-full flex items-center justify-center bg-gradient-to-br from-blue-50 via-white to-blue-100 p-4">
            <div className="absolute top-20 left-20 w-64 h-64 bg-blue-200 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-blob"></div>
            <div className="absolute bottom-20 right-20 w-72 h-72 bg-purple-200 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-blob animation-delay-2000"></div>

            <div className="relative w-full max-w-md">
                <div className="bg-white/80 backdrop-blur-lg p-10 rounded-3xl shadow-2xl border border-white/20">

                    {/* Header con Icono */}
                    <div className="flex flex-col items-center mb-8">
                        <div className="w-16 h-16 bg-blue-600 rounded-2xl flex items-center justify-center shadow-lg shadow-blue-200 mb-4 transform -rotate-3">
                            <School className="text-white w-10 h-10" />
                        </div>
                        <h1 className="text-4xl font-black text-gray-800 tracking-tight">
                            Jardín<span className="text-blue-600">App</span>
                        </h1>
                        <p className="text-gray-500 font-medium mt-1 text-sm uppercase tracking-widest">
                            Management System
                        </p>
                    </div>

                    <div className="space-y-6">
                        <div className="text-center">
                            <h2 className="text-xl font-bold text-gray-700">¡Bienvenido de nuevo!</h2>
                            <p className="text-gray-500 text-sm mt-1">Ingresa para gestionar tu comunidad educativa</p>
                        </div>

                        {/* Botón de Google Mejorado */}
                        <button
                            onClick={handleLogin}
                            className="group relative flex items-center justify-center gap-3 w-full bg-white border-2 border-gray-100 p-4 rounded-2xl hover:border-blue-500 hover:bg-blue-50 transition-all duration-300 shadow-sm hover:shadow-blue-100"
                        >
                            <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="Google" className="w-6 h-6 group-hover:scale-110 transition-transform" />
                            <span className="font-bold text-gray-700 group-hover:text-blue-700">Continuar con Google</span>
                            <ArrowRight className="w-4 h-4 text-gray-400 group-hover:text-blue-500 group-hover:translate-x-1 transition-all" />
                        </button>
                    </div>

                    {/* Footer del Card */}
                    <div className="mt-10 pt-6 border-t border-gray-100 flex items-center justify-center gap-2">
                        <ShieldCheck className="w-4 h-4 text-green-500" />
                        <p className="text-[11px] text-gray-400 font-medium uppercase tracking-tighter">
                            Acceso seguro para administradores autorizados
                        </p>
                    </div>
                </div>

                {/* Copyright simple fuera del card */}
                <p className="text-center mt-8 text-gray-400 text-sm font-medium">
                    &copy; 2026 Jardín Aplicación • The Cousins S.A.S.
                </p>
            </div>
        </div>
    );
};

export default Login;